import { useNavigate, useSearchParams } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { UniversalImporterEmployeeCompensationsPageDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { COMPENSATIONS_IMPORT_THRESHOLD_MAPPING } from 'modules/compensations/lib/constants'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalImporterEmployeeCompensationsPage = ({
  closePath,
}: {
  closePath: ((id: string) => string) | string
}) => {
  const [searchParams] = useSearchParams()
  const payrollRunId = searchParams.get('payroll-run-id')
  const {
    company,
    access: { locale },
  } = useCurrentSession()
  const navigate = useNavigate()
  const { data, error } = useQuery(UniversalImporterEmployeeCompensationsPageDocument, {
    fetchPolicy: 'network-only',
  })

  const canImportResources =
    data?.universalImporter?._policies.importResources.can &&
    payrollRunId !== null &&
    payrollRunId !== undefined

  const onClosePath = typeof closePath === 'function' ? closePath(payrollRunId || '') : closePath

  const onClose = () => {
    navigate(onClosePath)
  }

  if (data && (error || !canImportResources)) {
    navigate(onClosePath)
    return null
  }

  if (!payrollRunId) {
    navigate(-1)
    return null
  }

  if (!data || !canImportResources) {
    return null
  }

  return (
    <Modal
      illustration="table-file"
      title={i18n.t('compensation.routes.employee_compensations_universal_importer')}
      onClose={onClose}
      disableFocusTrap
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
        </Box>
      }
    >
      <NuvoImporter
        importType="compensations_employee_compensation_importer"
        locale={locale}
        companyId={company.id}
        metadata={{
          payroll_run_id: payrollRunId ? [payrollRunId] : [],
        }}
        thresholdMapping={COMPENSATIONS_IMPORT_THRESHOLD_MAPPING}
      />
    </Modal>
  )
}

export default UniversalImporterEmployeeCompensationsPage
